import {Directive, effect, ElementRef, inject, input} from "@angular/core";

@Directive({
	selector: "[appFocus]",
	standalone: false,
})
export class FocusDirective {
	appFocus = input.required<boolean>();
	elRef = inject(ElementRef);

	focusEffect = effect(() => this._focusEffect(this.appFocus()));

	private _focusEffect(focus: boolean): void {
		if (focus) {
			this.elRef.nativeElement.focus();
		} else {
			this.elRef.nativeElement.blur();
		}
	}
}
